import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton'
import s from './PaymentFormSkeleton.css'

function PaymentFormSkeleton() {
    return (
        <div className={s.paymentSkeletonBox}>
            <Skeleton className={s.paymentSkeletonTitle} />
            <div className={s.paymentSkeltonCardBox}>
                {[1, 2].map((n) => {
                    return (
                        <div key={n}>
                            <div className={s.paymentSkeletonCard}>
                                <div className={cx(s.paymentSkeletonCardTopFlex, s.paymentSkeletonCardDivider)}>
                                    <Skeleton className={s.paymentSkeletonCardLabel} />
                                    <Skeleton className={s.paymentSkeletonCardRadioBtn} />
                                </div>
                                <Skeleton className={s.paymentSkeletonCardLink} />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default withStyles(s)(PaymentFormSkeleton);
